/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogInResponse
 */
export interface LogInResponse {
    /**
     * 
     * @type {string}
     * @memberof LogInResponse
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof LogInResponse
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the LogInResponse interface.
 */
export function instanceOfLogInResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "refreshToken" in value;

    return isInstance;
}

export function LogInResponseFromJSON(json: any): LogInResponse {
    return LogInResponseFromJSONTyped(json, false);
}

export function LogInResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogInResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'refreshToken': json['refreshToken'],
    };
}

export function LogInResponseToJSON(value?: LogInResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'refreshToken': value.refreshToken,
    };
}

